module.exports = __webpack_public_path__ + "img/umbro-logo.616313f3.svg";